import { render, staticRenderFns } from "./SolicitudesPendientesTabla.html?vue&type=template&id=17fd58ff&external"
import script from "./SolicitudesPendientesTabla.vue?vue&type=script&lang=js"
export * from "./SolicitudesPendientesTabla.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesPendientesTabla.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports